<google-map [options]="options" height="100%" width="100%" (mapInitialized)="mapIsReady($event)" (mapClick)="clickOnMap($event)" >
  @if (pointer) {
    <map-marker
      [options]="{draggable:true}"
      (mapDragend)="moveMarker($event)"
      [icon]="pointer.icon??''"
      [position]="pointer.location"
      >
    </map-marker>
  }
  @if (markers) {
    @for (marker of markers; track marker) {
      <map-marker
        [icon]="marker.icon??''"
        #mapMarker="mapMarker"
        (mapClick)="openInfoWindow(mapMarker)"
        [position]="marker.location"
        >
      </map-marker>
      @if (marker.infoWindow) {
        <map-info-window>
          @if (marker.infoWindow.buttons) {
            @for (button of marker.infoWindow.buttons; track button) {
              <button mat-icon-button [color]="button.color"
                (click)="clickInfoWindowButton(button.action)">
                @if (button.iconMaterial) {
                  <mat-icon>
                    {{button.iconMaterial}}
                  </mat-icon>
                }
              </button>
            }
          }
        </map-info-window>
      }
    }
  }
</google-map>
